import { APPLE_COMMAND_KEY } from './constants';
/**
 * The italian translations.
 */
export const it = {
    gestureHandlingTouch: 'Utilizza due dita per spostare la mappa',
    gestureHandlingScroll: 'Utilizza CTRL + scorrimento per eseguire lo zoom della mappa',
    gestureHandlingScrollMac: `Utilizza ${APPLE_COMMAND_KEY} + scorrimento per eseguire lo zoom della mappa`,
    Transparency: 'trasparenza',
};
//# sourceMappingURL=it.js.map